import Accueil from './views/Accueil/Accueil';
import MonProfil from './views/Compte/MonProfil';
import Messagerie from './views/Compte/Messagerie';
import Administration from './views/Administration/Administration';
import Utilisateurs from './views/Administration/Utilisateurs';
import Tracings from './views/Administration/Tracings';
import ListeDemandesPassage from './views/Dossier/ListeDemandesPassage';
import DemandePassage from './views/Dossier/DemandePassage';
import CreateOrEditUtilisateurs from 'views/Administration/CreateOrEditUtilisateur'
import Referentiel from 'views/Administration/Referentiel'
import EditMetadatasReferentiel from 'views/Administration/EditMetadatasReferentiel'
import GrilleTarifaire from 'views/Administration/GrilleTarifaire'
import BlackList from "./views/Administration/Blacklist";
import ListeDevisFactures from "./views/Facturation/ListeDevisFactures";
import ElementsPatrimoines from 'views/Administration/ElementsPatrimoines';
import CreateOrEditElementsPatrimoines from "./views/Administration/CreateOrEditElementsPatrimoines";
import ContractViewer from "./views/Dossier/ContractViewer";
import DevisViewer from "./views/Facturation/DevisViewer";
import PlanificationViewer from "./views/Planification/PlanificationViewer";
import Statistiques from "./views/Administration/Statistiques";
import Centres from "./views/Administration/Centres";
import CreateOrEditGrilleTarifaire from 'views/Administration/CreateOrEditGrilleTarifaire';
import Parametrage from './views/Administration/Parametrage';
import EditParameter from './views/Administration/EditParameter';
import AgreementsViewer from './views/Facturation/AgreementsViewer';
import BilledThirdPartiesView from './views/Administration/BilledThirdParties';
import CreateOrEditBilledThirdParty from './views/Administration/CreateOrEditBilledThirdParty';


const routes = {
	Accueil: {
		component: Accueil, path: '/accueil',
	},
	MonProfil: {
		component: MonProfil, path: '/mon-profil', params: {
			color: '#0094ca'
		}
	},
	Messagerie: {
		component: Messagerie, path: '/messagerie', params: {
			color: '#0094ca'
		}
	},
	Administration: {
		component: Administration, path: '/panneau-administration', params: {
			color: '#0094ca'
		}
	},
	Utilisateurs: {
		component: Utilisateurs, path: '/panneau-administration/utilisateur', params: {
			color: '#0094ca'
		}
	},
	CreateOrEditUtilisateurs: {
		component: CreateOrEditUtilisateurs, path: '/panneau-administration/utilisateur/creation', params: {
			color: '#0094ca',
		}
	},
	Tracings: {
		component: Tracings, path: '/panneau-administration/tracing', params: {
			color: '#0094ca'
		}
	},
	ListeDemandesPassage: {
		component: ListeDemandesPassage, path: '/demande-passage/', params: {
			color: '#0094ca'
		}
	},
	DemandePassage: {
		component: DemandePassage, path: '/demande-passage/dossier', params: {
			color: '#0094ca'
		}
	},
	Referentiels: {
		component: EditMetadatasReferentiel, path: '/panneau-administration/referentiel/gestion', params: {
			color: '#0094ca'
		}
	},
	CreateOrEditReferentiel: {
		component: Referentiel, path: '/panneau-administration/referentiel', params: {
			color: '#0094ca'
		}
	},
	GrilleTarifaire: {
		component: GrilleTarifaire, path: '/panneau-administration/grille-tarifaire', params: {
			color: '#0094ca'
		}
	},
  CreateOrEditGrilleTarifaire: {
		component: CreateOrEditGrilleTarifaire, path: '/panneau-administration/grille-tarifaire/createOrEdit', params: {
			color: '#0094ca'
		}
	},
	BlackList: {
		component: BlackList, path: '/panneau-administration/blacklist', params: {
			color: '#0094ca'
		}
	},
	ElementsPatrimoines: {
		component: ElementsPatrimoines, path: '/panneau-administration/elements-patrimoines', params: {
			color: '#0094ca'
		}
	},
	CreationElementsPatrimoines: {
		component: CreateOrEditElementsPatrimoines, path: '/panneau-administration/elements-patrimoines/creation', params: {
			color: '#0094ca'
		}
	},
	editionElementsPatrimoines: {
		component: CreateOrEditElementsPatrimoines, path: '/panneau-administration/elements-patrimoines/edition', params: {
			color: '#0094ca'
		}
	},
	Parametrage: {
		component: Parametrage, path: '/panneau-administration/parametrage', params: {
			color: '#0094ca'
		}
	},
	EditionParametrage: {
		component: EditParameter, path: '/panneau-administration/parametrage/edition', params: {
			color: '#0094ca',
		}
	},
	ListeDevisFactures: {
		component: ListeDevisFactures, path: '/facturation', params: {
			color: '#0094ca'
		}
	},
	DevisViewer: {
		component: DevisViewer, path: '/facturation/devis', params: {
			type: "devis",
			color: '#0094ca'
		}
	},
	FactureViewer: {
		component: DevisViewer, path: '/facturation/facture', params: {
			type: "facture",
			color: '#0094ca'
		}
	},
	ContractViewer: {
		component: ContractViewer, path: '/demande-passage/contrat', params: {
			color: '#0094ca'
		}
	},
	AgreementViewer: {
		component: AgreementsViewer, path: '/demande-passage/accords-principe', params: {
			color: '#0094ca'
		}
	},
	PlanificationViewer: {
		component: PlanificationViewer, path: '/planification', params: {
			color: '#0094ca'
		}
	},
	Statistiques: {
		component: Statistiques, path: '/panneau-administration/statistiques', params: {
			color: '#0094ca'
		}
	},
	GestionCentres: {
		component: Centres, path: '/panneau-administration/centres', params: {
			color: '#0094ca'
		}
	},
	BilledThirdParties: {
		component: BilledThirdPartiesView, path: '/panneau-administration/tiers-factures', params: {
			color: '#0094ca'
		}
	},
	CreationBilledThirdParties: {
		component: CreateOrEditBilledThirdParty, path: '/panneau-administration/tiers-factures/creation', params: {
			color: '#0094ca'
		}
	},
	EditionBilledThirdParties: {
		component: CreateOrEditBilledThirdParty, path: '/panneau-administration/tiers-factures/edition', params: {
			color: '#0094ca'
		}
	},
};

export default routes;
